import { Css } from "~generated/css";
import { useTestIds } from "~utils";

type NoOptionsProps = {
  showExpiredOptions: boolean;
};

export function NoOptions({ showExpiredOptions }: NoOptionsProps) {
  const tid = useTestIds({}, "no-options");

  return (
    <div {...tid} css={Css.df.fdc.gap1.jcc.tac.mt("50%").$}>
      <span css={Css.t16.gray.$}>No {!showExpiredOptions && "Active"} Options</span>
      <span css={Css.t12.gray.$}>There are currently no {!showExpiredOptions && "active"} options available.</span>
    </div>
  );
}
